import { RemovePillId, ResolveMergeQuarantineDrug, UpdateDrug } from './../models/drug';
import { CreateDrug } from './../models/create-drug';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreateInventory, DestroyInventory } from '../models/inventory';
import { AssignCanister } from '../models/canister';
import { UpdateDcr } from './../models/drug';
import { AddDrugImage, ImageModel } from './../models/add-image';


@Injectable({
  providedIn: 'root'
})
export class RpoToolService {
  httpClient: HttpClient;
  url: string;
  constructor(http: HttpClient) {
    this.httpClient = http;
    this.url = environment.apiUrl.rpoToolService;
  }


  getDrugData(
    dataSourceId: number,
    searchText: string,
    permanentQuarantine: boolean,
    countryId: number,
    qReasonId: number,
    selectedSearchCriteria: any,
    modifiedBy: string,
    url: string = this.url + "RpoLandingScreen",
  ): Observable<any> {
    let params: any = {
      dataSourceId: dataSourceId,
      permanentQuarantine: permanentQuarantine,
      country_id: countryId,
      q_reason_id: qReasonId
    };
    if (!selectedSearchCriteria) {
      selectedSearchCriteria = { value: 'drugName' };
    }
    // Add search parameter based on selectedSearchCriteria
    switch (selectedSearchCriteria.value) {
      case 'drugName':
        params.name = searchText;
        break;
      case 'drugNumber':
        params.ndc = searchText;
        break;
      case 'pdbid':
        params.pddbId = searchText;
        break;
      case 'tcgid':
        params.tcgId = searchText;
        break;
      case 'genericNumber':
        params.genericNumber = searchText;
        break;
      case 'barcode':
        params.barcode = searchText;
        break;
      case 'dItem':
        params.dItem = searchText;
        break;
      default:
        params.ndc = searchText;
    }
    // Include 'modifiedBy' only if it's meaningful
    if (modifiedBy && modifiedBy.toLowerCase() !== 'null') {
      params.modifiedBy = modifiedBy;
    }

    return this.httpClient.get(url, {
      params: params,
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });

  }

  getSearchDrugData(
    dataSourceId: number,
    ndcOrName: string,
    country_id: number,
    pageNo: number,
    pageSize: number,
    selectedSearchCriteria: any,
    url: string = this.url + "SearchDrug"
  ): Observable<any> {
    let params: any = {
      dataSourceId: dataSourceId,
      country_id: country_id,
      pageNo: pageNo,
      pageSize: pageSize
    }
    if (!selectedSearchCriteria) {
      selectedSearchCriteria = { value: 'drugName' };
    }
    // Add search parameter based on selectedSearchCriteria
    switch (selectedSearchCriteria.value) {
      case 'drugName':
        params.name = ndcOrName;
        break;
      case 'drugNumber':
        params.ndc = ndcOrName;
        break;
      case 'pdbid':
        params.pddbId = ndcOrName;
        break;
      case 'tcgid':
        params.tcgId = ndcOrName;
        break;
      case 'genericNumber':
        params.genericNumber = ndcOrName;
        break;
      case 'barcode':
        params.barcode = ndcOrName;
        break;
      case 'dItem':
        params.dItem = ndcOrName;
        break;
      default:
        params.ndc = ndcOrName; // Default to NDC
    }

    return this.httpClient.get(url, {
      params: params,
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });

  }

  getSearchDrugDataV1(
    dataSourceId: number,
    searchText: string,
    selectedSearchCriteria: any,
    country_id: number,
    modifiedBy: string,
    pageNo: number,
    pageSize: number,
    url: string = this.url + "SearchDrug"
  ): Observable<any> {

    let params: any = {
      dataSourceId: dataSourceId,
      country_id: country_id,
      pageNo: pageNo,
      pageSize: pageSize
    };

    // Add search parameter based on selectedSearchCriteria
    switch (selectedSearchCriteria.value) {
      case 'drugName':
        params.name = searchText;
        break;
      case 'drugNumber':
        params.ndc = searchText;
        break;
      case 'pdbid':
        params.pddbId = searchText;
        break;
      case 'tcgid':
        params.tcgId = searchText;
        break;
      case 'genericNumber':
        params.genericNumber = searchText;
        break;
      case 'barcode':
        params.barcode = searchText;
        break;
      case 'dItem':
        params.dItem = searchText;
        break;
      default:
        params.ndc = searchText; // Default to NDC
    }

     // Include 'modifiedBy' only if it's meaningful
    if (modifiedBy && modifiedBy.toLowerCase() !== 'null') {
      params.modifiedBy = modifiedBy;
    }

    return this.httpClient.get(url, {
      params: params,
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getNewDrugHistory(
    dataSourceId: number,
    searchText: string,
    permanentQuarantine: boolean,
    country_id: number,
    pageNo: number,
    pageSize: number,
    selectedSearchCriteria: any,
    modifiedBy: string,
    url: string = this.url + "NewDrugHistory"
  ): Observable<any> {
    let params: any = {
      dataSourceId: dataSourceId,
      permanentQuarantine: permanentQuarantine,
      country_id: country_id,
      pageNo: pageNo,
      pageSize: pageSize
    }
    if (!selectedSearchCriteria) {
      selectedSearchCriteria = { value: 'drugName' };
    }

    // Add search parameter based on selectedSearchCriteria
    switch (selectedSearchCriteria.value) {
      case 'drugName':
        params.name = searchText;
        break;
      case 'drugNumber':
        params.ndc = searchText;
        break;
      case 'pdbid':
        params.pddbId = searchText;
        break;
      case 'tcgid':
        params.tcgId = searchText;
        break;
      case 'genericNumber':
        params.genericNumber = searchText;
        break;
      case 'barcode':
        params.barcode = searchText;
        break;
      case 'dItem':
        params.dItem = searchText;
        break;
      default:
        params.ndc = searchText; // Default to NDC
    }
    // Include 'modifiedBy' only if it's meaningful
    if (modifiedBy && modifiedBy.toLowerCase() !== 'null') {
      params.modifiedBy = modifiedBy;
    }

    return this.httpClient.get(url, {
      params: params,
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });

  }
  getQuarantinedDrugatav1(
    dataSourceId: number,
    searchText: string,
    permanentQuarantine: boolean,
    country_id: number,
    q_reason_id: number,
    pageNo: number,
    pageSize: number,
    selectedSearchCriteria: any,
    modifiedBy: string,
    url: string = this.url + "QuarantinedDrug"
  ): Observable<any> {
    let params: any = {
      dataSourceId: dataSourceId,
      permanentQuarantine: permanentQuarantine,
      country_id: country_id,
      q_reason_id: q_reason_id,
      pageNo: pageNo,
      pageSize: pageSize
    }
    if (!selectedSearchCriteria) {
      selectedSearchCriteria = { value: 'drugName' };
    }

    // Add search parameter based on selectedSearchCriteria
    switch (selectedSearchCriteria.value) {
      case 'drugName':
        params.name = searchText;
        break;
      case 'drugNumber':
        params.ndc = searchText;
        break;
      case 'pdbid':
        params.pddbId = searchText;
        break;
      case 'tcgid':
        params.tcgId = searchText;
        break;
      case 'genericNumber':
        params.genericNumber = searchText;
        break;
      default:
        params.ndc = searchText; // Default to NDC
    }
    // Include 'modifiedBy' only if it's meaningful
    if (modifiedBy && modifiedBy.toLowerCase() !== 'null') {
      params.modifiedBy = modifiedBy;
    }

    return this.httpClient.get(url, {
      params: params,
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });

  }
  getQuarantinedDrugata(
    dataSourceId: number,
    searchText: string,
    permanentQuarantine: boolean,
    country_id: number,
    q_reason_id: number,
    pageNo: number,
    pageSize: number,
    selectedSearchCriteria: any,
    modifiedBy: string,
    url: string = this.url + "QuarantinedDrug"
  ): Observable<any> {
    let params: any = {
      dataSourceId: dataSourceId,
      permanentQuarantine: permanentQuarantine,
      country_id: country_id,
      q_reason_id: q_reason_id,
      pageNo: pageNo,
      pageSize: pageSize
    }
    if (!selectedSearchCriteria) {
      selectedSearchCriteria = { value: 'drugName' };
    }

    // Add search parameter based on selectedSearchCriteria
    switch (selectedSearchCriteria.value) {
      case 'drugName':
        params.name = searchText;
        break;
      case 'drugNumber':
        params.ndc = searchText;
        break;
      case 'pdbid':
        params.pddbId = searchText;
        break;
      case 'tcgid':
        params.tcgId = searchText;
        break;
      case 'genericNumber':
        params.genericNumber = searchText;
        break;
      default:
        params.ndc = searchText; // Default to NDC
    }

    // Include 'modifiedBy' only if it's meaningful
    if (modifiedBy && modifiedBy.toLowerCase() !== 'null') {
      params.modifiedBy = modifiedBy;
    }
    return this.httpClient.get(url, {
      params: params,
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });

  }

  getDcrDrugs(
    pageNo: number,
    pageSize: number,
    caseOwner: string,
    drugNumber: string,
    name: string,
    url: string = this.url + "GetDcrDrugs"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: {
        pageNo: pageNo,
        pageSize: pageSize,
        owner: caseOwner,
        drugNumber: drugNumber,
        name: name,
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getDcrDrugsByCaseNo(
    caseNo: string,
    url: string = this.url + "GetDcrDrugsByCaseNo"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: {
        caseNo: caseNo,
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getDrugDetailsByNdc(
    ndc: any,
    dataSourceId: number,
    url: string = this.url + "GetDrugByNDC"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: {
        ndc: ndc,
        dataSourceId: dataSourceId
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getCoating(
    url: string = this.url + "GetCoating"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }
calculateSynmedValues(request: any, url: string = this.url + "SynmedCalculations"): Observable<any> {
  return this.httpClient.post(url, JSON.stringify(request), {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
  });
}

calculateTcgValues(request: any, url: string = this.url + "TcgCalculations"): Observable<any> {
  return this.httpClient.post(url, JSON.stringify(request), {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
  });
}
calculateMaxValues(request: any, url: string = this.url + "MaxCalculations"): Observable<any> {
  return this.httpClient.post(url, JSON.stringify(request), {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
  });
}

calculateThirtyDramCapacityValues(request: any, url: string = this.url + "ThirtyDramCapacityCalculations"): Observable<any> {
  return this.httpClient.post(url, JSON.stringify(request), {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
  });
}

  getCountry(
    url: string = this.url + "GetCountry"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getDataSourceFilter(
    url: string = this.url + "GetDataSourceFilter"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }


  getClassificationShape(
    url: string = this.url + "GetClassificationShape"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getCountryList(
    url: string = this.url + "GetCountryList"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getScheduleList(
    url: string = this.url + "GetSchedule"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getPillShapeList(
    url: string = this.url + "GetPillShape"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getDrugClassificationType(
    url: string = this.url + "GetDrugNumberType"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getDrugNumberFormat(
    url: string = this.url + "GetDrugNumberFormat"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getCommonDrugStatus(
    url: string = this.url + "CommonDrugStatus"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }
  getPassDrugStatus(
    url: string = this.url + "PassDrugStatus"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }
  getMaxDrugStatus(
    url: string = this.url + "MaxDrugStatus"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getSynmedDrugStatus(
    url: string = this.url + "SynmedDrugStatus"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }
  getAtpDrugStatus(
    url: string = this.url + "AtpDrugStatus"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

getPnrList(
    url: string = this.url + "GetPnrList"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getPillType(
    url: string = this.url + "GetPillType"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }
  getScoring(
    url: string = this.url + "GetScoring"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }
  getSchedule(
    url: string = this.url + "GetSchedule"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getUnit(
    search: string,
    url: string = this.url + "GetUnit"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: {
        search: search
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getDrugName(
    search: string,
    url: string = this.url + "GetDrugName"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: {
        search: search
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getGenericName(
    search: string,
    url: string = this.url + "GetGenericName"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: {
        search: search
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getQuarantineReasonList(
    url: string = this.url + "GetQuarantineReasonList"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }
  getDrugNonCountReasonList(
    url: string = this.url + "GetDrugNonCountReasonList"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getModifierList(
    url: string = this.url + "GetDrugModifierList"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getManufacture(
    search,
    url: string = this.url + "GetManufacture"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: {
        search: search
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }
  getDistributor(search): Observable<any> {
    return this.httpClient.get(this.url + "GetDistributor", {
      params: {
        search: search
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }
  getRecommendedDrug(
    length: any,
    width: any,
    thickness: any,
    weight: any,
    diagonal: any,
    classificationShapeId: any,
    url: string = this.url + "GetRecommendedDrug"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: {
        Length: length,
        Width: width,
        Thickness: thickness,
        Weight: weight,
        Diagonal: diagonal,
        ClassificationShapeId: classificationShapeId
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }
  GetDrugByClassificationIdAndNdc(

    classificationShapeId: any,
    ndc,
    sourceId: any,
    url: string = this.url + "GetDrugByClassificationIdAndNdc"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: {
        classificationId: classificationShapeId,
        ndc: ndc,
        sourceId: sourceId
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getOtc(
    url: string = this.url + "GetOtc"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getRouteOfAdministration(
    search: any,
    url: string = this.url + "GetRouteOfAdministration"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: {
        search: search
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }
  getColor(
    search: any,
    url: string = this.url + "GetColor"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: {
        search: search
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getDrugId(
    search: any,
    url: string = this.url + "GetDrugByDrugID"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: {
        search: search
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getDosageForm(
    search: any,
    url: string = this.url + "GetDosageForm"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: {
        search: search
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }


  getNiosh(
    url: string = this.url + "GetNiosh"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getPackageType(
    search: string,
    url: string = this.url + "GetPackageType"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: {
        search: search
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getPackageSize(
    id: string,
    search: string,
    url: string = this.url + "GetPackageSize"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: {
        id: id,
        search: search
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }
  getImages(
    ndc: string,
    id: number,
    url: string = this.url + "SliderImage"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: {
        ndc: ndc,
        id: id
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }


  getDataSource(
    url: string = this.url + "GetDataSource"
  ): Observable<any> {
    return this.httpClient.get(url, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }
  saveDrug(
    savedrug: CreateDrug,
    url: string = this.url + "insert-drug"
  ): Observable<any> {
    return this.httpClient.post(url, JSON.stringify(savedrug), {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }
  updateDrug(
    drug: UpdateDrug,
    url: string = this.url + "EditDrug"
  ): Observable<any> {
    return this.httpClient.put(url, JSON.stringify(drug), {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  checkQuarantineDrugAlreadyResolved(
    alternateId: string,
    url: string = this.url + "CheckQuarantineDrugAlreadyResolved"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: {
        alternateId: alternateId
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  resolveMergeQuarantine(
    quarantineDrugData: ResolveMergeQuarantineDrug,
    url: string = this.url + "ResolveMergeQuarantine"
  ): Observable<any> {
    return this.httpClient.post(url, JSON.stringify(quarantineDrugData), {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  assignCanister(
    assignCanister: AssignCanister,
    url: string = this.url + "AssignSelectedCanister"
  ): Observable<any> {
    return this.httpClient.put(url, JSON.stringify(assignCanister), {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }
  getInventoryById(
    id: any,
    url: string = this.url + "GetInventoryById"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: {
        id: id
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }



  getInventoryByNDC(
    ndc: any,
    url: string = this.url + "GetInventoryByNdc"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: {
        ndc: ndc
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }
  saveInventory(
    saveInventory: CreateInventory,
    url: string = this.url + "SaveInventory"
  ): Observable<any> {
    return this.httpClient.post(url, JSON.stringify(saveInventory), {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }


  destroyInventory(
    updateInventory: DestroyInventory,
    url: string = this.url + "UpdateInventory"
  ): Observable<any> {
    return this.httpClient.put(url, JSON.stringify(updateInventory), {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getDrugSourceByNDC(
    ndc: any,
    url: string = this.url + "GetDrugSources"
  ): Observable<any> {
    return this.httpClient.get(url + "?search=" + ndc, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  updateDcr(
    caseNo: any,
    drug: UpdateDcr,
    url: string = this.url + "UpdateDcrDrugs"
  ): Observable<any> {
    return this.httpClient.put(url, JSON.stringify(drug), {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
      params:{caseNo}
    });
  }

  changeOrRemovePillId(
    ndc: string,
    dataSourceId: number,
    model: RemovePillId,
    url: string = this.url + "ChangeOrRemovePillId"
  ): Observable<any> {

    return this.httpClient.put(url, JSON.stringify(model), {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
      params: {
        ndc,
        dataSourceId
      }
    });
  }


  getPillIdByNdc(
    ndc: string,
    dataSourceId: any,
    url: string = this.url + "GetPillIdByNdc"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: {
        ndc,
        dataSourceId
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  getDrugNameStrengthAndUnitByNameAndDrugNumber(
    drugName: string,
    drugNumber: string,
    qReason: string,
    url: string = this.url + "GetDrugNameStrengthAndUnitByName"
  ): Observable<any> {
    return this.httpClient.get(url, {
      params: {
        drugName,
        qReason,
        drugNumber
      },
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  saveDrugImage(
    adddImageModel: AddDrugImage,
    url: string = this.url + "AddNewDrugImage"
  ): Observable<any> {
    console.log("addImageModel",adddImageModel)
    return this.httpClient.post(url, JSON.stringify(adddImageModel), {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    });
  }

  deleteDrugImage(
    blobName: string,
    url: string = this.url + "DeleteImage"
  ): Observable<any> {

    return this.httpClient.post(url, '', {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
      params: {
        blobName
      }
    });
  }

}
